export default {"src":"/_next/static/media/vagrant_on-light.97d51e15.svg","height":72,"width":207,"blurWidth":0,"blurHeight":0};